import { SpinLoading } from 'antd-mobile';
import { useTranslation } from 'react-i18next';
import './Loading.scss';

export const Loading = ({ overlay = false }) => {
  const { t } = useTranslation();

  return (
    <div className={overlay ? 'global-spinner-overlay' : 'global-spinner'}>
      <h3>{t('common.loading')}</h3>
      <SpinLoading color="primary" />
    </div>
  );
};
